import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import { container } from '../services/container'

import SpecialIngredient from '@/components/SpecialIngredient/SpecialIngredient'

import WebviewLoginPage from '@/components/Webview/WebviewLoginPage'

import NewsletterConfirm from '@/components/NewsletterConfirm'
import SignInOauthToken from '@/components/SignInOauthToken'
import LegalReferral from '@/components/LegalReferral'
import LegalCookies from '@/components/LegalCookies'
import LegalPrivacy from '@/components/LegalPrivacy'
import PageNotFound from '@/components/PageNotFound'
import InviteFriend from '@/components/InviteFriend'
import Unavailable from '@/components/Unavailable'
import UnavailableMenu from '@/components/Checkout/UnavailableMenu'
import LoadingPage from '@/components/LoadingPage'
import RecipePage from '@/components/RecipePage'
import OldRecipePage from '@/components/OldRecipePage'
import InfoSocial from '@/components/InfoSocial'
import LoginPage from '@/components/LoginPage'
import Freshdesk from '@/components/Freshdesk'
import Investors from '@/components/Investors'
import Manifesto from '@/components/Manifesto'
import Cookbook from '@/components/Cookbook'
import Recovery from '@/components/Recovery'
import GiftCard from '@/components/GiftCard'
import FaqPage from '@/components/FaqPage'
import Fastweb from '@/components/Fastweb'
import MealKit from '@/components/MealKit'
import Recipes from '@/components/Recipes'
import Legal from '@/components/Legal'
import Plans from '@/components/Plans'
import SubscriptionStepPage from '@/components/Checkout/SubscriptionStepPage'
import HomeMain from '@/components/Home/HomeMain'
import HomeDashboard from '@/components/Home/HomeDashboard'

import LandingGalbani from '@/components/Landing/LandingGalbani'
import SourceTunnel from '@/components/Checkout/SourceTunnel'
import LandingTortellini from '@/components/Landing/LandingTortellini'
import LandingPavesini from '@/components/Landing/LandingPavesini'
import LandingBoxMixed from '@/components/Landing/LandingBoxMixed'
import LandingEdenTree from '@/components/Landing/LandingEdenTree'
import LandingMartini from '@/components/Landing/LandingMartini'
import LandingB2B from "@/components/Landing/LandingB2B";
import LandingElectrolux from '@/components/How/LandingElectrolux'
import YourStatistics from '@/components/How/YourStatistics'
import HowWeRecycle from '@/components/How/HowWeRecycle'
import SupplierPage from '@/components/How/SupplierPage'
import ProductOrigin from '@/components/How/ProductOrigin'
import HowWeCreate from '@/components/How/HowWeCreate'
import BoxShipment from '@/components/How/BoxShipment'
import Instruction from '@/components/How/Instruction'
import HowItWorks from '@/components/How/HowItWorks'
import Suppliers from '@/components/How/Suppliers'
import OurTeam from '@/components/How/OurTeam'
import SubscriptionLocked from '@/components/Checkout/SubscriptionLocked'
import HomeShop from '@/components/Checkout/HomeShop'
import Ecommerce from '@/components/Ecommerce/Ecommerce'
import ProductPage from '@/components/Ecommerce/ProductPage'
import NewPlans from '@/components/NewPlans'
import ThankYouPageRecurring from '@/components/Checkout/ThankYouPageRecurring'
import FlowSubscribed from '@/components/Checkout/FlowSubscribed'
import PayPalCheckout from '@/components/Checkout/PayPalCheckout'
import StripeCheckout from '@/components/Checkout/StripeCheckout'
import EdenredCheckout from '@/components/Checkout/EdenredCheckout'
import ThankYouPage from '@/components/Checkout/ThankYouPage'
import VerifyPage from '@/components/Checkout/VerifyPage'
import OrderNow from '@/components/Checkout/OrderNow'
import OrderNowBoxes from '@/components/Checkout/OrderNowBoxes'
import FlowNew from '@/components/Checkout/FlowNew'

import InviteFriendProfile from '@/components/Profile/InviteFriend'
import ChangeAddress from '@/components/Profile/ChangeAddress'
import Subscription from '@/components/Profile/Subscription'
import NextOrder from '@/components/Profile/NextOrder'
import Password from '@/components/Profile/Password'
import Account from '@/components/Profile/Account'
import Profile from '@/components/Profile/Profile'
import Payment from '@/components/Profile/Payment'
import Orders from '@/components/Profile/Orders'

import Guard from '../middlewares/Guard'

import Meta from 'vue-meta'
import LegalPrivacyBennet from "../partners/bennet/LegalPrivacyBennet.vue";
import LegalPrivacyGalbani from '../partners/galbani/LegalPrivacyGalbani'
import CookiePolicyGalbani from '../partners/galbani/CookiePolicyGalbani'
import HowItWorksGalbani from '../partners/galbani/HowItWorksGalbani'
import GalbaniGuard from '../partners/galbani/Guard'

import HowItWorksBennet from '../partners/bennet/HowItWorksBennet'
import BennetGuard from '../partners/bennet/Guard'

import { giftcardConfig } from '../config/giftcards'
import { orderNowConfig } from '../config/orderNow'
import { voielloConfig } from '../config/voiello'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
	mode: process.env.VUE_APP_DEVICE ? 'hash' : 'history',
	hashbang: false,
	history: true,

	routes: [
		{
			path: '/',
			component: Main,
			children: [
				{
					path: '/',
					name: 'home',
					component: HomeMain,
					beforeEnter: Guard.dashboardController
				},

				{
					path: '/my-quomi',
					name: 'dashboard',
					component: HomeDashboard,
					beforeEnter: Guard.dashboardController
				},

				{
					path: '/home',
					name: 'home-def',
					redirect: '/'
				},

				{
					path: '/ortofrutta-quomi',
					name: 'product-origin',
					component: ProductOrigin
				},

				{
					path: '/food-box-quomi',
					name: 'foodbox',
					component: HomeMain
				},

				{
					path: 'san-valentino',
					name: 'san-valentino',
					redirect: 'gift-card'
				},

				{
					path: 'wishlist',
					name: 'wishlist',
					component: LoginPage
				},

				{
					path: 'admin',
					name: 'admin',
					component: LoadingPage,
					beforeEnter (to, from, next) {
						next()
						location.href = container.get('admin_url')
					}
				},

				{
					path: 'le-ricette',
					redirect: 'ricette'
				},

				{
					path: 'prova-ora',
					name: 'order-now',
					component: OrderNow,
          meta: {
            footer: false,
            newsletterModal: false,
            freshdesk: false,
            header: false,
            headerCheckout: false,
            config: orderNowConfig
          }
					/* redirect: '/checkout/scegli-ricette' */
				},

				{
					path: 'box-voiello-procida',
					name: 'order-now-voiello',
					component: OrderNow,
          meta: {
            footer: false,
            newsletterModal: false,
            freshdesk: false,
            header: false,
            headerCheckout: false,
            config: voielloConfig
          }
				},

				{
					path: 'prova-le-cassette',
					name: 'order-now-boxes',
					component: OrderNowBoxes,
					meta: {
            header: false,
						footer: false,
						newsletterModal: false,
						freshdesk: false,
					}
				},

				{
					path: '/checkout/sospeso',
					name: 'subscription.locked',
					component: SubscriptionLocked
				},
        /*
				{
					path: '/checkout/subscription',
					name: 'subscription',
					component: Subscription,
					meta: {
            header: 'checkout',
						newsletterModal: false,
					}
				},
        */
				{
					path: '/checkout/step-subscription',
					name: 'subscription-step',
					component: SubscriptionStepPage,
          meta: {
            header: 'checkout',
						newsletterModal: false,
					}
				},

				{
					path: 'ricette',
					name: 'recipes',
					component: Recipes,
					beforeEnter: Guard.closedOrder,
					meta: {
						freshdesk: false
					}
				},

				{
					path: 'ricette',
					name: 'recipes-preview',
					component: Recipes,
					meta: {
						freshdesk: false
					}
				},

				{
					path: 'supporto',
					name: 'freshdesk',
					component: Freshdesk,
					beforeEnter: Guard.freshdesk,
					meta: {
						footer: true,
						newsletterModal: false,
						freshdesk: false
					}
				},

				{
					path: 'livefast',
					name: 'fastweb',
					component: Fastweb,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'info-societarie',
					name: 'info-social',
					component: InfoSocial,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'manifesto',
					name: 'manifesto',
					component: Manifesto
				},

				{
					path: 'le-tue-statistiche-su-quomi',
					name: 'your-statistics',
					component: YourStatistics
				},

				{
					path: 'gift-card',
					name: 'gift-card',
					component: GiftCard,
					meta: {
						newsletterModal: false,
						config: giftcardConfig
					}
				},

				{
					path: '/user/profile',
					name: 'profile',
					component: Profile,
					beforeEnter: Guard.profileControl,
					// add guards,
          meta: {
            header: 'main'
          },
					children: [
            {
              path: 'account',
              name: 'profile_account',
              component: Account,
              meta: {
                header: 'main'
              },
            },
						{
							path: 'subscription',
							name: 'profile_subscription',
							component: Subscription,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'next-order',
							name: 'profile_next-order',
							component: NextOrder,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'orders',
							name: 'profile_orders',
							component: Orders,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'cambia-indirizzo',
							name: 'profile_shipment',
							component: ChangeAddress,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'payment',
							name: 'profile_payment',
							component: Payment,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'invite-friend',
							name: 'profile_invite-friend',
							component: InviteFriendProfile,
              meta: {
                header: 'main'
              },
						},

						{
							path: 'password',
							name: 'profile_password',
							component: Password,
              meta: {
                header: 'main'
              },
						}
					]
				},

				{
					name: 'invite-friend',
					path: 'invita-un-amico',
					component: InviteFriend,
					meta: {
						newsletterModal: false,
            header: 'main'
					}
				},

				{
					path: 'piani',
					name: 'plans',
					component: NewPlans,
					beforeEnter: Guard.new,
					meta: {
            header: 'checkout',
						newsletterModal: false
					}
				},

				{
					path: 'legal',
					name: 'legal',
					component: Legal,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'legal-referral',
					name: 'legal-referral',
					component: LegalReferral,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'privacy-policy',
					name: 'privacy-policy',
					component: LegalPrivacy,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'privacy-policy/bennet',
					name: 'privacy-policy/bennet',
					component: LegalPrivacyBennet,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'privacy-policy/galbani',
					name: 'privacy-policy/galbani',
					component: LegalPrivacyGalbani,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'come-funziona/galbani',
					name: 'how-it-works/galbani',
					component: HowItWorksGalbani,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'come-funziona/bennet',
					name: 'how-it-works/bennet',
					component: HowItWorksBennet,
					meta: {
						newsletterModal: false
					}
				},


				{
					path: 'cookies-policy',
					name: 'cookies-policy',
					component: LegalCookies,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'cookies-policy/galbani',
					name: 'cookies-policy/galbani',
					component: CookiePolicyGalbani,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'su-quomi-arriva-la-carta-payback',
					redirect: '/'
				},

				{
					path: 'carta-millemiglia-su-quomi',
					redirect: '/'
				},

				{
					path: 'le-nostre-ricette',
					name: 'cookbook',
					component: Cookbook,
					meta: {
						newsletterModal: false,
						disableScroll: true,
						freshdesk: false
					}
				},

				{
					path: 'prodotti-extra',
					redirect: 'checkout/ricette'
				},

				{
					path: 'meal-kit',
					name: 'meal-kit',
					component: MealKit,
					props: { template: 'meal-kit' },
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'scopri-box-quomi',
					name: 'box-quomi',
					component: MealKit,
					props: { template: 'box-quomi' },
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'checkout/recipes/:id',
					name: 'recipe',
					component: RecipePage,
					meta: {
            header: 'checkout',
						newsletterModal: false
					}
				},
				{
					path: 'checkout/ricetta/:id',
					name: 'cookbook-recipe',
					component: RecipePage,
					meta: {
            header: 'main',
						newsletterModal: false
					}
				},
				{
					path: 'ricetta/:id',
					name: 'recipe',
					component: OldRecipePage,
					meta: {
						newsletterModal: false
					}
				},
				{
					path: 'checkout/prodotto/:id',
					name: 'product',
					component: ProductPage,
					meta: {
            header: 'checkout',
						newsletterModal: false
					}
				},
				{
					path: 'checkout/prodotto/:id/:slug',
					name: 'product',
					component: ProductPage,
					meta: {
            header: 'checkout',
						newsletterModal: false
					}
				},
				{
					path: 'legumotti',
					name: 'legumotti',
					component: SpecialIngredient,
					props: { template: 'legumotti' }
				},

				{
					path: 'pasta-nutracentis',
					name: 'nutracentis',
					component: SpecialIngredient,
					props: { template: 'nutracentis' }
				},

				{
					path: 'penne-di-lenticchie-rosse',
					name: 'lenticchie',
					component: SpecialIngredient,
					props: { template: 'lenticchie' }
				},

				{
					path: 'cioccolato-granblocco-perugina',
					name: 'perugina',
					component: SpecialIngredient,
					props: { template: 'perugina' }
				},

				{
					path: 'spaghetti-di-verdure',
					name: 'spaghetti-di-verdure',
					component: SpecialIngredient,
					props: { template: 'spaghetti' }
				},

				{
					path: 'come-funziona',
					name: 'how-it-works',
					component: HowItWorks
				},

				{
					path: 'come-creiamo-le-ricette',
					name: 'how-we-create',
					component: HowWeCreate
				},

				{
					path: 'come-riciclare-la-tua-box',
					name: 'how-we-recycle',
					component: HowWeRecycle
				},

				{
					path: 'idee-e-ricette-per-forno-a-vapore',
					name: 'electrolux',
					component: LandingElectrolux
				},

				{
					path: 'pianta-un-albero',
					name: 'edenTree',
					component: LandingEdenTree
				},

				/*{
					path: 'galbani',
					name: 'galbani',
					component: LandingGalbani
				},*/

				{
					path: 'pavesini-snack',
					name: 'pavesini',
					component: LandingPavesini
				},
				{
					path: 'tortellini-carne-non-carne',
					name: 'tortellini',
					component: LandingTortellini
				},
				{
					path: 'kit-aperitivo-martini-casa',
					name: 'kit-aperitivo-martini-casa',
					component: LandingMartini
				},

				{
					path: 'cassette-frutta-e-verdura-a-domicilio',
					name: 'landing-box-mixed',
					component: LandingBoxMixed
				},
				{
					path: 'regali-per-dipendenti-ed-eventi',
					name: 'landing-b2b',
					component: LandingB2B,
					meta: {
						newsletterModal: false
					}
				},
				{
					path: 'leffe',
					redirect: '/'
				},
				{
					path: 'source/leffe',
					redirect: '/'
				},
				{
					path: 'source/:source',
					name: 'source',
					component: SourceTunnel
				},
        {
          path: 'dona-la-spesa',
					name: 'enel',
          redirect: 'source/enel',
        },
				{
					path: 'cassette-frutta-e-verdura',
					redirect: 'cassette-frutta-e-verdura-a-domicilio'
				},
				{
					path: 'chi-siamo',
					name: 'our-team',
					component: OurTeam,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'dal-produttore-al-consumatore',
					name: 'suppliers',
					component: Suppliers
				},

				{
					path: 'dal-produttore-al-consumatore/:id',
					name: 'supplier',
					component: SupplierPage
				},

				{
					path: 'viaggio-climatizzato',
					name: 'box-shipment',
					component: BoxShipment
				},

				{
					path: 'passo-per-passo',
					name: 'instruction',
					component: Instruction
				},

				{
					path: 'faq',
					name: 'faq',
					component: FaqPage,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'checkout/subscription',
					name: 'flow-new',
					component: FlowNew,
					beforeEnter: Guard.new,
					meta: {
            header: 'checkout',
						footer: false,
						newsletterModal: false,
						freshdesk: false
					}
				},

				{
					path: 'checkout/thank-you',
					name: 'thank-you-new',
					component: ThankYouPage,
					beforeEnter: Guard.subscribed,
					meta: {
            headerCheckout: false,
						footer: false,
						newsletterModal: false
					}
				},
				{
					path: 'checkout/verify',
					name: 'verify-page',
					component: VerifyPage,
					beforeEnter: Guard.subscribed,
					meta: {
            header: 'checkout',
						footer: false,
						newsletterModal: false
					}
				},

				{
					path: 'checkout/thank-you-prova-ora',
					name: 'thank-you-prova-ora',
					component: ThankYouPage,
					beforeEnter: Guard.subscribed,
					meta: {
            headerCheckout: false,
						newsletterModal: false
					}
				},

				{
					path: 'checkout/thank-you-prova-ora-v2',
					name: 'thank-you-prova-ora-v2',
					component: ThankYouPage,
					beforeEnter: Guard.subscribed,
					meta: {
            headerCheckout: false,
						newsletterModal: false
					}
				},

				{
					path: '/bottega',
					name: 'shop',
					component: HomeShop,
					meta: {
            header: 'checkout',
						newsletterModal: false
					}
				},

				{
					name: 'flow-subscribed',
					path: '/checkout/scegli-ricette',
					redirect: '/checkout/ricette'
				},

				{
					path: '/checkout/:tag',
					name: 'shop-by-tag',
					component: FlowSubscribed,
					beforeEnter: Guard.checkClosed,
					meta: {
            header: 'checkout',
						footer: true,
						freshdesk: false,
						newsletterModal: false
					}
				},


				{
					path: 'checkout/ordine-confermato',
					name: 'thank-you-recurring',
					component: ThankYouPageRecurring,
					beforeEnter: Guard.orderControl,
					meta: {
						footer: false,
            headerCheckout: false,
						freshdesk: false,
						newsletterModal: false
					}
				},
				
				{
					path: 'checkout/aggiungi-prodotti-extra',
					redirect: 'checkout/ricette'
				},
				{
					path: 'checkout/aggiungi-prodotti-extra',
					name: 'ecommerce',
					redirect: "/checkout/scegli-ricette"
				},

				{
					path: 'checkout/extra-ordine-confermato',
					name: 'thank-you-ecommerce',
					redirect: 'checkout/ordine-confermato'
				},

				{
					path: 'recovery/password',
					name: 'recovery',
					component: Recovery,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: 'ricette-non-disponibili',
					name: 'unavailable',
					component: UnavailableMenu,
					meta: {
						newsletterModal: false,
            header: 'no-checkout'
					}
				},

				{
					path: 'investors',
					name: 'investors',
					component: Investors,
					meta: {
            header: 'investors',
						newsletterModal: false
					}
				},

				{
					path: '/login',
					name: 'login-page',
					component: LoginPage,
					meta: {
						footer: false,
						newsletterModal: false
					}
				},

				{
					path: '/wv-login',
					name: 'wv-login-page',
					component: WebviewLoginPage,
					meta: {
						footer: false,
						newsletterModal: false
					}
				},

				{
					path: '/newsletter/confirm',
					name: 'newsletter-confirm',
					component: NewsletterConfirm,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: '/oauth/edenred/token',
					name: 'edenred',
					component: EdenredCheckout,
					meta: {
						footer: false,
						freshdesk: false,
						newsletterModal: false
					}
				},

				{
					path: '/oauth/:provider/token',
					name: 'sign-in-token',
					component: SignInOauthToken,
					meta: {
						newsletterModal: false
					}
				},

				{
					path: '/:refer/paypal/:status',
					name: 'paypalcheckout',
					component: PayPalCheckout,
					meta: {
						footer: false,
						freshdesk: false,
						newsletterModal: false
					}
				},
        
        {
          path: '/:refer/stripe',
          name: 'stripecheckout',
          component: StripeCheckout,
          meta: {
            footer: false,
            freshdesk: false,
            newsletterModal: false
          }
        }
			] // main
		},

		{
			path: '*',
			name: '404',
			component: PageNotFound
		}
	],

	scrollBehavior (to, from, savedPosition) {
		if (to.matched.some(m => m.meta.disableScroll)) return
		return savedPosition ? savedPosition : { x: 0, y: 0 }
	}
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}


let g = GalbaniGuard
let b = BennetGuard

router.beforeEach(g.check)
router.beforeEach(b.check)

export default router
